module.exports = __webpack_public_path__ + "img/erweima.6f5c6ae8.png";